import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosService } from "../../../services/axios.service";
import { urls } from "../../../constants";

const initialState = {
  data: [],
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 1,
  status: null,
  error: null,
};

const getChangelog = createAsyncThunk(
  "changelogSlice/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const res = await axiosService.get(urls.messages.changelog, { params });
      return res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || "Something went wrong");
    }
  }
);

const changelogSlice = createSlice({
  name: "changelogSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getChangelog.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getChangelog.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getChangelog.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: changelogReducer } = changelogSlice;
const changelogActions = { getChangelog };

export { changelogReducer, changelogActions };
